exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td.exist_error[data-v-82b0eba4]{border:1px solid red}.text-set[data-v-82b0eba4]{position:relative;top:-25px;margin-left:160px}", ""]);

// exports
